var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFhTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4437 0.96875C28.3369 0.96875 36.3337 8.98347 36.3337 18.8587C36.3337 28.7519 28.3369 36.7487 18.4437 36.7487C8.56843 36.7487 0.553711 28.7519 0.553711 18.8587C0.553711 8.98347 8.56843 0.96875 18.4437 0.96875ZM17.8176 9.78852C17.0841 9.78852 16.4758 10.3789 16.4758 11.1303V20.1647C16.4758 20.6299 16.7263 21.0592 17.1377 21.3097L24.1506 25.4959C24.3653 25.6212 24.5979 25.6927 24.8483 25.6927C25.2956 25.6927 25.7428 25.4602 25.9933 25.0308C26.369 24.4046 26.1722 23.5817 25.5281 23.1881L19.1593 19.3954V11.1303C19.1593 10.3789 18.551 9.78852 17.8176 9.78852Z",
    fill: "#135478"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFhTime);
export default __webpack_public_path__ + "static/media/ic_fh_time.a81313065cc3cc5d5772f08c2e692d95.svg";
export { ForwardRef as ReactComponent };